var types_UpperFunnelJobToBeDoneEnum = /*#__PURE__*/ function(UpperFunnelJobToBeDoneEnum) {
    UpperFunnelJobToBeDoneEnum["BUY"] = "BUY";
    UpperFunnelJobToBeDoneEnum["DOWNLOAD_RESOURCE"] = "DOWNLOAD_RESOURCE";
    UpperFunnelJobToBeDoneEnum["FREE_COURSE"] = "FREE_COURSE";
    UpperFunnelJobToBeDoneEnum["FREE_COURSE_OF_THE_DAY"] = "FREE_COURSE_OF_THE_DAY";
    UpperFunnelJobToBeDoneEnum["SOFE"] = "SOFE";
    return UpperFunnelJobToBeDoneEnum;
}({});
var types_UpperFunnelSourceEnum = /*#__PURE__*/ function(UpperFunnelSourceEnum) {
    UpperFunnelSourceEnum["APP"] = "APP";
    UpperFunnelSourceEnum["BLOG"] = "BLOG";
    UpperFunnelSourceEnum["DEEP_LINK"] = "DEEP_LINK";
    UpperFunnelSourceEnum["DOWNLOAD_RESOURCE_FROM_COURSE_DETAIL"] = "DOWNLOAD_RESOURCE_FROM_COURSE_DETAIL";
    UpperFunnelSourceEnum["DOWNLOAD_RESOURCE_FROM_TOOLS_LANDING"] = "DOWNLOAD_RESOURCE_FROM_TOOLS_LANDING";
    UpperFunnelSourceEnum["FREE_COURSES_BANNER"] = "FREE_COURSES_BANNER";
    UpperFunnelSourceEnum["FREE_COURSES_CARD"] = "FREE_COURSES_CARD";
    UpperFunnelSourceEnum["FREE_COURSES_DETAIL"] = "FREE_COURSES_DETAIL";
    UpperFunnelSourceEnum["FREE_COURSE_OF_THE_DAY_LANDING"] = "FREE_COURSE_OF_THE_DAY_LANDING";
    UpperFunnelSourceEnum["GUEST_CHECKOUT"] = "GUEST_CHECKOUT";
    UpperFunnelSourceEnum["HOME"] = "HOME";
    UpperFunnelSourceEnum["PUSH"] = "PUSH";
    UpperFunnelSourceEnum["SIGNUP_VIEW"] = "SIGNUP_VIEW";
    return UpperFunnelSourceEnum;
}({});
export { types_UpperFunnelJobToBeDoneEnum as UpperFunnelJobToBeDoneEnum, types_UpperFunnelSourceEnum as UpperFunnelSourceEnum };
